module.exports = __webpack_public_path__ + "fonts/StagSans-Medium.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Medium.otf
// module id = 1090
// module chunks = 0